import { Button, Icon } from '@britishcouncil/react-admin';
import { ROUTING_PATHS } from 'const';
import { useIntParam } from 'hooks';
import { Link, generatePath } from 'react-router';

export const AddRoomButton = () => {
  const { addRoomToLrwSession } = ROUTING_PATHS;
  const sessionId = useIntParam('sessionId');

  return (
    <Link
      data-testid="add-room-link"
      to={generatePath(addRoomToLrwSession.absolutePath, {
        sessionId: sessionId,
      })}
    >
      <Button compact primary>
        <Icon name="plus square" />
        Add room
      </Button>
    </Link>
  );
};
